// language=GraphQL
const userProfile = `
  query
    userProfile {
      userProfile {
        profile {
          customerId
        }
      }
    }
`;

export default userProfile;
